<div class="challenge" *ngFor="let challenge of challenges" [class.active]="challenge.isActive">
	<div class="challenge-description">{{ challenge.description }}</div>
	<div class="challenge-count">{{ challenge.count }}</div>
	<div class="challenge-amount">{{ formatAmount(challenge) }}</div>
	<div class="challenge-total">{{ formatTotal(challenge) }}</div>
</div>
